import { render } from "./ModalDetailChart.vue?vue&type=template&id=58c534f9"
import script from "./ModalDetailChart.vue?vue&type=script&lang=js"
export * from "./ModalDetailChart.vue?vue&type=script&lang=js"

import "./ModalDetailChart.vue?vue&type=style&index=0&id=58c534f9&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__